import { styled } from '../../../styles';

export const Video = styled('div', {
	video: {
		// border: '2px solid red',
		position: 'fixed',
		top: 0,
		right: 0,
		left: 0,
		bottom: 0,
		width: '100%',
		height: 'auto',
		minWidth: '100%',
		minHeight: '100%',
		objectFit: 'cover',
		zIndex: '99999',
	},

	canvas: {
		display: 'none',
	}
});
